import React from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLayout({ children }) {

  const navigate = useNavigate();

  const logout = async () => {

    await fetch(
      "https://brightlifephysio.com/api/logout.php",
      {
        credentials: "include"
      }
    );

    navigate("/brightlife-admin-login");
  };

  return (

    <div className="admin-layout">

      {/* HEADER */}
      <div className="admin-header">

        <div>
          <h2 className="admin-logo">
            BrightLife Physio
          </h2>

          <p className="admin-subtitle">
            Clinic Management
          </p>
        </div>

        <button
          className="logout-btn"
          onClick={logout}
        >
          Logout
        </button>

      </div>

      {/* CONTENT */}
      <div className="admin-content">

        {children}

      </div>

      {/* FOOTER */}
      <div className="admin-footer">

        © 2026 BrightLife Physio

      </div>

    </div>
  );
}